export default __webpack_public_path__ + "static/media/background-image.1e4ea07e.jpg";